<template>
  <v-app v-if="apiKey" style="position: absolute; width: 100vw; height: 100vh">
    <v-main class="Kanit" id="webchat">
      <transition
        name="fade"
        mode="out-in"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
      >
        <template v-if="loading"></template>
        <Main v-else />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import Main from './views/Main.vue'
import { config } from '@/constants/page.js'

export default {
  name: 'App',
  props: ['apiKey'],

  components: {
    Main
  },

  data: () => ({
    prevHeight: 0,
    loading: true
  }),
  async mounted() {
    this.loading = true
    this.$store.state.apiKey = this.apiKey

    const setting = config[this.apiKey]

    // Light theme
    this.$vuetify.theme.defaults.light.primary = setting.primaryColor
    this.$vuetify.theme.themes.light.primary = setting.primaryColor

    // Dark theme
    this.$vuetify.theme.defaults.dark.primary = setting.primaryColor
    this.$vuetify.theme.themes.dark.primary = setting.primaryColor

    const id = localStorage.getItem('id')
    const pageid = setting.pageid

    if (id) {
      this.$store.state.id = id
      this.$store.commit('SET_LOGIN_STATUS', true)

      await this.chatlog(id, pageid)
    }
    this.loading = false
  },
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter(element) {
      const { height } = getComputedStyle(element)

      element.style.height = this.prevHeight

      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    }
  },
  computed: {
    bgcolor() {
      return this.$store.state.bgcolor
    }
  }
}
</script>
<style>
@import './styles/style.scss';
#App {
  position: absolute;
  width: 100vw;
  height: 100vh;
}

* {
  box-sizing: border-box;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.Kanit {
  font-family: 'Kanit', sans-serif !important;
}
</style>
